const checkPhone = (rule, value, callback) => {
    if (!value) {
        callback();
    }
    // if (!value) {
    //     return callback(new Error("手机号码不能为空"));
    // }
    setTimeout(() => {
        if (!Number.isInteger(+value)) {
            callback(new Error("请输入数字值"));
        } else {
            const phoneReg = /^1[2-9][0-9]{9}$/;
            if (phoneReg.test(value)) {
                callback();
            } else {
                callback(new Error("手机号码格式不正确"));
            }
        }
    }, 100);
};

export default checkPhone;